import {
  Box,
  Drawer,
  DrawerContent,
  useColorModeValue,
  useDisclosure,
} from '@chakra-ui/react';
import React, { ReactNode } from 'react';

import { MobileNav } from './MobileNav';
import { SidebarContent } from './SidebarContent';
import { ILinkItemProps } from './SidebarItem';

interface SidebarWithHeaderProps {
  sidebarItems: ILinkItemProps[];
  children: ReactNode;
}

export const SidebarWithHeader: React.FC<SidebarWithHeaderProps> = ({
  sidebarItems,
  children,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box minH="100vh" bg={useColorModeValue('gray.50', 'gray.900')}>
      {/* Mobile navigation bar */}
      <MobileNav onOpen={onOpen} />

      {/* Sidebar for desktop */}
      <SidebarContent
        onClose={onClose}
        sidebarLinkItems={sidebarItems}
        display={{ base: 'none', md: 'block' }}
      />

      {/* Drawer for mobile */}
      <Drawer
        autoFocus={false}
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        returnFocusOnClose={false}
        onOverlayClick={onClose}
        size="xs"
      >
        <DrawerContent>
          <SidebarContent onClose={onClose} sidebarLinkItems={sidebarItems} />
        </DrawerContent>
      </Drawer>

      {/* Main content area */}
      <Box
        ml={{ base: 0, md: '260px' }}
        px={{ base: 4, md: 8 }}
        pt="100px"
        pb="6"
        transition="margin-left 0.2s ease"
      >
        {children}
      </Box>
    </Box>
  );
};
